import { ComponentStylesWithFns } from '../../theme/styles.helpers';

type TypeBadgeStates = { variant: 'rezept' | 'befundung' };

export const TypeBadgeStyles: ComponentStylesWithFns<TypeBadgeStates> = {
  badge: ({ variant }) => [
    {
      display: 'inline-flex',
      alignItems: 'center',
      height: '21px',
      borderRadius: '20px',
      border: '1px solid',
      px: '10px',
      fontSize: '10px',
      fontWeight: 700,
      whiteSpace: 'nowrap',
    },
    variant === 'rezept' && {
      backgroundColor: '#ebf2ff',
      borderColor: '#c7d2fe',
      color: '#4881d7',
    },
    variant === 'befundung' && {
      backgroundColor: '#fff8e6',
      borderColor: '#f6ad55',
      color: '#b7791f',
    },
  ],
};
